var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderForm',{attrs:{"order":_vm.order,"buttonLoading":_vm.buttonLoading,"params":_vm.getParams},on:{"saveOrder":_vm.saveOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }